// extracted by mini-css-extract-plugin
export default {"title":"style_title__SLMZM","titleWithButton":"style_titleWithButton__nLo+O","backIcon":"style_backIcon__RfiP2","h1":"style_h1__SKEeo","h4":"style_h4__+1xkx"};